import { isEmpty } from "./utils/helpers";

const baseEnv = isEmpty(process.env.REACT_APP_ENV) ? window._env_ : process.env;

const getEnv = (key, fallback = "") => {
  const value = baseEnv[key];
  if (!value) {
    console.warn(`⚠️ ENV Missing: ${key}`);
    return fallback;
  }
  return value;
};


export const REACT_APP_ENV = getEnv("REACT_APP_ENV");

// Core APIs
export const REACT_APP_API = getEnv("REACT_APP_API_URL");
export const REACT_APP_API_DID_URL = getEnv("REACT_APP_DID_API_URL");
export const REACT_APP_PAM_API = getEnv("REACT_APP_PAM_API_URL");
export const REACT_APP_API_SAM_URL = getEnv("REACT_APP_SAM_API_URL");

// Base URL for policy-service (EvaluateAuth, DiscoverADPolicies, etc.)
export const REACT_APP_POLICY_API =
  getEnv("REACT_APP_POLICY_API_URL", "") || getEnv("REACT_APP_API_URL");

// ad-gateway-control base URL for /api/v1/diagnostics/* (status, unlock).
// Falls back to REACT_APP_API when the gateway is reachable through the
// existing API gateway proxy. Set REACT_APP_AD_GATEWAY_URL per env to
// point at a dedicated host.
export const REACT_APP_AD_GATEWAY_URL =
  getEnv("REACT_APP_AD_GATEWAY_URL", "") || getEnv("REACT_APP_API_URL");

// URLs templated into sensor.yml at download time.
// Override per env in .env-cmdrc; fall back to the main API base URL when unset.
export const REACT_APP_AD_SERVICE_URL =
  getEnv("REACT_APP_AD_SERVICE_URL", "") || getEnv("REACT_APP_API_URL");

export const REACT_APP_POLICY_SERVICE_URL =
  getEnv("REACT_APP_POLICY_SERVICE_URL", "") ||
  getEnv("REACT_APP_POLICY_API_URL", "") ||
  getEnv("REACT_APP_API_URL");


//DIRECTORY AND PRIVELAGED ACCESS MANAGEMENT
export const REACT_APP_API_PAM_URL = getEnv("REACT_APP_PAM_API_URL");

//TRASACTIONS LOGS

// Okta + Auth Services
export const REACT_APP_API_OKTA = getEnv("REACT_APP_URL");
export const REACT_APP_API_TENANTS_URL = getEnv("REACT_APP_TENANTS_API_URL");


// JUMPSERVER
export const JUMPSERVER_CONNECTION_PORT = Number(getEnv("REACT_APP_JUMPSERVER_CONNECTION_PORT", 8080));

// AI Agent
export const REACT_APP_AI_API_URL = getEnv("REACT_APP_AI_API_URL");


// OTHERS
export const REACT_APP_REDIRECT_URL = getEnv("REACT_APP_REDIRECT_URL");
export const TENANT_ID = getEnv("REACT_APP_TENANT_ID");
export const ORG_NAME = getEnv("REACT_APP_ORG_NAME");
export const REACT_APP_URL = getEnv("REACT_APP_URL");

// AUTHENTICATION URL
export const REACT_APP_AUTHENTICATION_URL = getEnv("REACT_APP_AUTHENTICATION_URL");

//ORGNIZATION ID
export const ORG_ID = () => {
  let OrgId = localStorage.getItem("OrgId");
  return Number(OrgId);
};

//OKTA TOKEN
export const AUTH_TOKEN = () => {
  let token = localStorage.getItem("token");
  let domainUrl = localStorage.getItem("URL");
  return `${token}&DOMAIN&${domainUrl}&ORGID&${ORG_ID()}`;
};

export const AUTH_TOKEN_ORG = () => {
  let domainUrl = localStorage.getItem("URL");
  let token = localStorage.getItem("token");
  let orgId = localStorage.getItem("OrgId");
  return `${token}&DOMAIN&${domainUrl}&ORGID&${orgId}&ORGLOGIN&`;
};

//DOMAIN ID
export const DOMAIN_ID = () => {
  let domainId = localStorage.getItem("DomainId");
  return Number(domainId);
};

export const USER_EMAIL = () => {
  return localStorage.getItem("UserName");
};